import { GridCellProps } from '@progress/kendo-react-grid';
import { TextBoxChangeEvent } from '@progress/kendo-react-inputs';
import { FC, useMemo } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import TextInput from 'src/components/TextInput';
import { useContextSelector } from 'use-context-selector';
import { InvoiceContext } from '../InvoiceDetailsContext';
import useDelayedInputOnchange from 'src/hooks/useDelayedInputOnchange';

const GlCodesNotes: FC<GridCellProps> = (props) => {
  const isInvoiceEditDisabled = useContextSelector(
    InvoiceContext,
    (value) => value.isInvoiceEditDisabled
  );
  const glBreakout = useContextSelector(InvoiceContext, (value) => value.errors.glBreakout);
  const setIsGlCodesDirty = useContextSelector(InvoiceContext, (value) => value.setIsGlCodesDirty);
  const { dataItem, dataIndex } = props;

  const { value, handleChange } = useDelayedInputOnchange(props, true);

  const inputOnChange = (e: TextBoxChangeEvent) => {
    setIsGlCodesDirty(true);
    handleChange(e);
  };
  const isTotals = useMemo(() => dataItem.rowId === 'noExpand', [dataItem.rowId]);

  if (isTotals) {
    return (
      <GridCellBase {...props}>
        <></>
      </GridCellBase>
    );
  }

  return (
    <GridCellBase {...props}>
      {isInvoiceEditDisabled ? (
        <p className="text-left">{value}</p>
      ) : (
        <TextInput
          type={'text'}
          valid={!glBreakout?.[dataIndex]?.notes?.length}
          value={value}
          onChange={inputOnChange}
        />
      )}
    </GridCellBase>
  );
};

export default GlCodesNotes;
